var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicScore1Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.42,
    height: 180.335,
    viewBox: "0 0 162.42 180.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4363",
    "data-name": "Group 4363",
    transform: "translate(-1290.945 -320.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4336",
    "data-name": "Group 4336",
    transform: "translate(1292.445 378.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3206",
    "data-name": "Group 3206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3205",
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M227.145,225.924a79.722,79.722,0,0,1-69.1-119.454.386.386,0,1,1,.669.386,78.937,78.937,0,1,0,136.674-.338.386.386,0,1,1,.667-.389,79.723,79.723,0,0,1-68.907,119.8Z",
    transform: "translate(-147.435 -105.936)",
    fill: "#acd94d",
    stroke: "#acd94d",
    strokeLinecap: "round",
    strokeWidth: 3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4337",
    "data-name": "Group 4337",
    transform: "translate(1305.955 352.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M231.119,204.785a66.2,66.2,0,1,1,66.2-66.2A66.274,66.274,0,0,1,231.119,204.785Z",
    transform: "translate(-164.919 -72.378)",
    fill: "#f0f3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4338",
    "data-name": "Group 4338",
    transform: "translate(1305.956 320.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3214",
    "data-name": "Group 3214",
    transform: "translate(16.436 17.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M190.025,57.645l-1.034-5.236a.587.587,0,0,1,.836-.64l4.785,2.363,4.66-2.6a.587.587,0,0,1,.868.6l-.77,5.281,3.915,3.628a.587.587,0,0,1-.3,1.009l-5.261.9-2.24,4.844a.588.588,0,0,1-.518.341h-.015a.588.588,0,0,1-.52-.314l-2.482-4.725-5.3-.634a.587.587,0,0,1-.351-.993Z",
    transform: "translate(-186.131 -51.455)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3215",
    "data-name": "Group 3215",
    transform: "translate(56.456 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M253.793,49.371a.581.581,0,0,1-.273-.067l-5.826-3.063L241.867,49.3a.588.588,0,0,1-.853-.619l1.113-6.488L237.414,37.6a.588.588,0,0,1,.326-1l6.514-.947,2.913-5.9a.587.587,0,0,1,1.053,0l2.913,5.9,6.515.947a.588.588,0,0,1,.325,1L253.259,42.2l1.113,6.488a.587.587,0,0,1-.579.686Z",
    transform: "translate(-237.236 -29.424)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3216",
    "data-name": "Group 3216",
    transform: "translate(98.622 17.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M299.6,68.132h-.015a.586.586,0,0,1-.518-.341l-2.241-4.844-5.26-.9a.587.587,0,0,1-.3-1.009l3.915-3.628-.77-5.281a.587.587,0,0,1,.868-.6l4.66,2.6,4.785-2.363a.587.587,0,0,1,.836.64l-1.034,5.236,3.727,3.821a.587.587,0,0,1-.35.993l-5.3.634-2.482,4.725A.588.588,0,0,1,299.6,68.132Z",
    transform: "translate(-291.082 -51.455)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3217",
    "data-name": "Group 3217",
    transform: "translate(122.045 42.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M325.456,94.294a.6.6,0,0,1-.123-.013.587.587,0,0,1-.446-.431l-.727-2.879-2.782-1.033a.587.587,0,0,1-.109-1.048l2.513-1.581.122-2.967a.588.588,0,0,1,.963-.427l2.28,1.9,2.859-.8a.587.587,0,0,1,.7.784l-1.1,2.756,1.645,2.472a.587.587,0,0,1,.019.619.58.58,0,0,1-.547.292l-2.962-.2-1.843,2.328A.586.586,0,0,1,325.456,94.294Z",
    transform: "translate(-320.993 -83.78)",
    fill: "#3fc468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    transform: "translate(0 42.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M171.035,94.294a.587.587,0,0,1-.461-.222l-1.842-2.328-2.963.2a.587.587,0,0,1-.528-.912l1.645-2.471-1.1-2.756a.587.587,0,0,1,.7-.784l2.859.8,2.28-1.9a.587.587,0,0,1,.962.427l.123,2.966,2.513,1.581a.587.587,0,0,1-.108,1.048l-2.784,1.033-.727,2.879a.588.588,0,0,1-.446.431A.6.6,0,0,1,171.035,94.294Z",
    transform: "translate(-165.142 -83.781)",
    fill: "#3fc468"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4349",
    "data-name": "Group 4349",
    transform: "translate(1 -29.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4346",
    "data-name": "Group 4346",
    transform: "translate(1345.541 432.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4345",
    "data-name": "Group 4345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4343",
    "data-name": "Group 4343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    "data-name": "Path 3524",
    d: "M377.5,137.386c0,4.1-1.974,7.433-4.41,7.433s-4.409-3.328-4.409-7.433,1.974-7.433,4.409-7.433S377.5,133.281,377.5,137.386Z",
    transform: "translate(-368.681 -129.953)",
    fill: "#6f6f6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4344",
    "data-name": "Group 4344",
    transform: "translate(44.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    "data-name": "Path 3525",
    d: "M440.3,137.386c0,4.1-1.974,7.433-4.41,7.433s-4.41-3.328-4.41-7.433,1.974-7.433,4.41-7.433S440.3,133.281,440.3,137.386Z",
    transform: "translate(-431.485 -129.953)",
    fill: "#6f6f6f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4348",
    "data-name": "Group 4348",
    transform: "translate(1336.461 416.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    d: "M448.182,118.069c-.644-.188-1.27-.363-1.882-.534-1.345-.376-2.615-.732-3.841-1.157a34.041,34.041,0,0,1-5.044-2.144,29.961,29.961,0,0,1-4.558-2.957,44.994,44.994,0,0,1-4.337-3.976.26.26,0,0,0-.445.2,11.4,11.4,0,0,0,2.339,6.109,14.926,14.926,0,0,0,5.063,4.306,15.753,15.753,0,0,0,6.117,1.759l.246.016a13.181,13.181,0,0,0,6.38-1.133.26.26,0,0,0-.038-.484Z",
    transform: "translate(-377.291 -107.224)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    d: "M355.936,118.069c.644-.188,1.27-.363,1.882-.534,1.345-.376,2.615-.732,3.842-1.157a34.031,34.031,0,0,0,5.043-2.144,29.971,29.971,0,0,0,4.558-2.957A45.153,45.153,0,0,0,375.6,107.3a.26.26,0,0,1,.444.2,11.4,11.4,0,0,1-2.338,6.109,14.922,14.922,0,0,1-5.063,4.306,15.746,15.746,0,0,1-6.117,1.759l-.246.016a13.183,13.183,0,0,1-6.381-1.133.26.26,0,0,1,.039-.484Z",
    transform: "translate(-355.749 -107.224)",
    fill: "#6f6f6f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    "data-name": "Path 3528",
    d: "M373.718,188.621c-.626.072-.984-.7-.978-1.281a18.25,18.25,0,0,1,2.109-8.073,22.587,22.587,0,0,1,5.388-6.667,25.64,25.64,0,0,1,16.11-5.842,24.374,24.374,0,0,1,16.218,5.808,20.422,20.422,0,0,1,7.394,14.757c.01.612-.4,1.4-1.084,1.279-.563-.1-1.022-.864-1.435-1.208-.638-.531-1.3-1.034-1.979-1.513a40.138,40.138,0,0,0-4.239-2.592,31.8,31.8,0,0,0-17.626-3.895,30.386,30.386,0,0,0-11.16,3.291,39.013,39.013,0,0,0-5.925,3.772c-.706.54-1.866,1.99-2.736,2.155Z",
    transform: "translate(975.651 291.793)",
    fill: "#6f6f6f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicScore1Star);
export default __webpack_public_path__ + "static/media/graphic_score_1star.a0e2b11df29ab9b5635d10f658789150.svg";
export { ForwardRef as ReactComponent };